import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 下载按钮 */
const DownloadButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

DownloadButton.defaultProps = {
  icon: ICON_COLLECTION.DOWNLOAD,
  text: '下载',
};

export default DownloadButton;
